import Box from '@mui/material/Box';
import CardContent from '@mui/material/CardContent';
import CardHeader from '@mui/material/CardHeader';
import Grid from '@mui/material/Grid';
import { useTheme } from '@mui/material/styles';
import React, { useState } from 'react';
import { constants } from '../../constants';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMLink } from '../../ui-elements/MyMLink';
import { OutlinedCustomCard } from '../../ui-parts/OutlinedCustomCard';
import { Pager } from '../../ui-parts/Pager';
import { useNavigate } from 'react-router-dom';
import { MyMProgressPartially } from '../../ui-elements/MyMProgressPartially';
import { FilterMenu } from '../../ui-parts/FilterMenu';


/**
 * NewsList Items Component
 */
const NewsListResultCard = ({ screenId, apiRequest, controlSettings, messageList, newsList, setListPageNum, listPageNum, setIsLoading, isLoading, isPc, setApliableFilterList, metadataList, checkedList, setCheckedList, content }) => {

  // スタイル
  const theme = useTheme();
  // 2024.5.8 MyMine Version1.5対応 Add Start
  const navigate = useNavigate();
  // 2024.5.8 MyMine Version1.5対応 Add End

  // 2024.9.16 MyMine Version2.0対応 Add Start
  const [isOpenFilterMenu, setIsOpenFilterMenu] = useState(false);
  const openFilterMenu = () => setIsOpenFilterMenu(true);
  const closeFilterMenu = () => setIsOpenFilterMenu(false);
  // 2024.9.16 MyMine Version2.0対応 Add End

  // 2024.5.8 MyMine Version1.5対応 Modify Start
  const navigateNewsPage = (newsId, url, newsType) => {
    if (newsType === constants.NewsType.InternalNews) {
      // InternalNews
      navigate(`MyM502/${newsId}`);
      return;
    } else {
      // GlobalSiteNews
      apiRequest.requestJson('api/news/external-link-transition?newsId=' + newsId, 'GET', null, null, null);
      window.open(url, '_blank');
    }
  }
  // 2024.5.8 MyMine Version1.5対応 Modify End

  const NewsListItem = ({
    // 2024.5.8 MyMine Version1.5対応 Add Start
    newsId,
    // 2024.5.8 MyMine Version1.5対応 Add End
    date,
    newsType,
    url,
    title,
    contents,
    isNew,
    isContentsAbbreviate }) => {

    return (
      <Grid container spacing={1} className="mt-0" sx={{
        width: "100%",
        marginLeft: "0",
        '&:nth-of-type(odd)': { backgroundColor: "#bdbdbd" },
      }}>
        <Grid item xs={12} md={0.6}>
          <MyMLabel color={"#f00"} sx={{ fontWeight: "bold", paddingLeft: "5px", display: isNew ? "block" : "none" }}>{controlSettings.LabelList.lblNewIcon}</MyMLabel>
        </Grid>
        <Grid item xs={12} md={11.4}>
          <MyMLabel>{date}
            <MyMImage
              screenId={screenId}
              filePath={newsType === constants.NewsType.GlobalNews ? 'corporate_icon.png' : 'gm_original_icon.png'}
              alt={newsType === constants.NewsType.GlobalNews ? "CorporateIcon" : "GM Original Icon"}
              width="60px"
              height="20px"
              display="block"
              sx={{ opacity: "0.5", zIndex: "10" }}
            />
          </MyMLabel>
          <MyMLink
            // 2024.5.8 MyMine Version1.5対応 Modify Start
            onClick={() => { navigateNewsPage(newsId, url, newsType) }}
            // 2024.5.8 MyMine Version1.5対応 Modify End
            sx={{ color: "#000", fontWeight: "bold", textDecorationColor: "#000" }}>
            {title}
          </MyMLink>
          <MyMLabel sx={{ marginBottom: "0.5vw", color: "#000" }}>
            {contents}
            {contents != null && isContentsAbbreviate ? // contentsが省略表示されている場合、ReadMoreリンクを表示
              <MyMLink
                // 2024.5.8 MyMine Version1.5対応 Modify Start
                onClick={() => { navigateNewsPage(newsId, url, newsType) }}
                // 2024.5.8 MyMine Version1.5対応 Modify End
                sx={{ fontSize: "1rem", marginLeft: "15px" }}>
                {controlSettings.LabelList.lnkReadMore}
              </MyMLink>
              :
              <></>
            }
          </MyMLabel>
        </Grid>
      </Grid>
    );
  };

  return (
    <OutlinedCustomCard>
      <CardHeader
        sx={{ display: 'flex', background: theme.palette.background.secondary, height: '10%' }}
        title={<MyMLabel sx={{ color: 'white' }}>{controlSettings.LabelList.lblNewsListTitle}</MyMLabel>}

      />
      <Grid item xs={11} sx={{ textAlign: 'right', marginTop:'10px' }}>
        {
          !isPc &&
          <>
            <FilterMenu
              isOpenFilterMenu={isOpenFilterMenu}
              openFilterMenu={openFilterMenu}
              closeFilterMenu={closeFilterMenu}
              content={metadataList}
              controlSettings={controlSettings}
              setApliableFilterList={setApliableFilterList}
              checkedList={checkedList}
              setCheckedList={setCheckedList}
            />
          </>
        }
      </Grid>
      <CardContent sx={{ height: 600 }}>
        {
          newsList !== undefined && newsList.ItemList !== undefined && Object.entries(newsList.ItemList).length > 0 ?
            <>
              <Box sx={{ border: 1, borderColor: '#999', borderRadius: '10px', height: '89%', marginBottom: '10px', overflowY: "auto", position: 'relative' }}>
                {isLoading && <MyMProgressPartially />}
                {
                  newsList.ItemList.map((item, index) => {
                    return (
                      <NewsListItem
                        key={index}
                        // 2024.5.8 MyMine Version1.5対応 Add Start
                        newsId={item.NewsId}
                        // 2024.5.8 MyMine Version1.5対応 Add End
                        date={item.FormatPublishDate}
                        newsType={item.NewsType}
                        url={item.Url}
                        title={item.Title}
                        contents={item.Contents}
                        isNew={item.IsNew}
                        isContentsAbbreviate={item.IsContentsAbbreviate}
                      ></NewsListItem>
                    )
                  })}
              </Box>
              <Pager
                resultListItem={newsList}
                handleChangePage={(pageNum) => setListPageNum(pageNum)}
                labelList={controlSettings.LabelList}
                pageNumber={listPageNum}>
              </Pager>
            </>
            :
            <MyMLabel sx={{ margin: "1vw" }}>{messageList.MyM_MSG_I_0059}</MyMLabel>
        }
      </CardContent>
    </OutlinedCustomCard>
  );
}
export default NewsListResultCard;
